import { Controller } from "@hotwired/stimulus"

// "Planification en lot" (page d'édition d'une vente flash) : ajoute des
// champs date supplémentaires pour dupliquer la vente courante vers
// d'autres jours en une seule action.
export default class extends Controller {
  static targets = ["dates"]

  add(event) {
    event.preventDefault()
    const row = document.createElement("div")
    row.className = "admin-duplicate-date-row"
    row.innerHTML = `
      <input type="date" name="dates[]" class="form-control" required>
      <button type="button" class="btn btn-sm btn-outline-danger" data-action="flash-sale-duplicate#remove">Retirer</button>
    `
    this.datesTarget.appendChild(row)
  }

  remove(event) {
    event.preventDefault()
    event.currentTarget.closest(".admin-duplicate-date-row")?.remove()
  }
}
